export const notificationTypes = {
  ShippingSplitted: { id: 1, title: "Разбиение Поставки" },
  ShippingDamage: { id: 2, title: "Повреждение Поставки" },
  ShippingMessageFromCabinetClient: { id: 3, title: "Сообщения из Кабинета клиента" },
};